import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import { SecondaryShell } from '@/app/layout/SecondaryShell';
import { useMe } from '@/features/me/MeContext';
import { renderLabel } from '@/i18n/renderLabel';
import { MANAGE_NAVIGATION } from '@/manage/navigation';
import { cn } from '@/lib/cn';

/** Beheer's own left nav — sections filtered by the caller's permissions,
 * same item styling as the main `Sidebar`/`ProfileNav`/`SettingsNav`. */
function ManageNav({ onNavigate }: { onNavigate?: (() => void) | undefined }) {
  const { t } = useTranslation();
  const { permissions } = useMe();
  const sections = MANAGE_NAVIGATION.filter((section) => section.visible(permissions));

  return (
    <nav aria-label={t('shell.sectionNav')} className="flex flex-col gap-6">
      {sections.map((section) => (
        <div key={section.id}>
          <p className="text-mint mb-2 text-[11px] font-bold tracking-wider uppercase">
            {renderLabel(t, section.labelKey)}
          </p>
          <ul className="m-0 flex list-none flex-col gap-1 p-0">
            {section.items.map((item) => (
              <li key={item.id}>
                <NavLink
                  to={item.to}
                  onClick={onNavigate}
                  className={({ isActive }) =>
                    cn(
                      'rounded-pill block h-9 px-3 text-sm leading-9',
                      'hover:bg-mint-tint',
                      isActive ? 'bg-mint text-ink font-semibold' : 'text-ink',
                    )
                  }
                >
                  {renderLabel(t, item.labelKey)}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </nav>
  );
}

/** The "Beheer" shell (§ Beheer) — `SecondaryShell` with `ManageNav` as its
 * left-hand nav. */
export function ManageLayout() {
  return <SecondaryShell nav={(onNavigate) => <ManageNav onNavigate={onNavigate} />} />;
}
